export const HOME_TRANSLATE = {
    home: {
        breadcrumbName: "Inicio",
        actions: {
            goToLogin: {
                text: "Área de clientes"
            },
            goToJoinin: {
                text: "Quiero conocer"
            },
            followUpComplaints: {
                text: "Seguir mi denuncia"
            }
        }
    }
}
